<kendo-card style="width: 100%; padding-bottom: 0px;">
	<!-- does not work in css -->
	<kendo-card-header>
		<!-- Optionsverzeichnis -->
		<img src="../../assets/images/logo.png" alt="logo" width="40">
	</kendo-card-header>
	<kendo-card-body>
	<span i18n="Common|Logout message">You've been logged out. Use CRM to enter the Designer again.</span>
	</kendo-card-body>
</kendo-card>